
import { defineComponent, ref } from 'vue';
export default defineComponent({
  name: 'GuideNav',
  setup() {
    // 导航栏内容
    const tags = [
      {
        icon: 'el-icon-user',
        index: 'illustrate',
        title: '网站使用说明',
      },
      {
        icon: 'el-icon-user-solid',
        index: 'help',
        title: '查看出行帮助',
        subs: [
          {
            icon: 'el-icon-user-solid',
            index: 'insurance_plane',
            title: '航空综合险条款',
          },
          {
            icon: 'el-icon-user-solid',
            index: 'insurance_ticket',
            title: '无忧退票险条款',
          },
          {
            icon: 'el-icon-user-solid',
            index: 'passenger',
            title: '乘客须知',
          },
        ],
      },
    ];
    return {
      tags,
      defaultActive: ref('illustrate'),
    };
  },
});
